
import Vue from "vue";
import { BankService, DossierConfigService } from "@/services";
import { CtepBrandID, getBrandName } from "@/utils/ctep/ctep-brands";
import { BankType } from "@/models/base";
import AppBankConfigureCtepTerminalBankPerBrandSettings from "./BankConfigureCtepBankTypePerBrandSettingsEditModal.vue";
import { ICtepDefaultBankForPaymentType } from "@/models/dossier-configs/bank-config";
import { CtepService } from "@/services/ctep-service";

export default Vue.extend({
	data(){
		return {
			settings: DossierConfigService.getBankConfig(),
			saving: false,
			BankService,
			toEditBankIdForBrandSetting: null as null | ICtepDefaultBankForPaymentType
		};
	},
	computed: {
		hasModule():boolean {
			return CtepService.hasModule();
		},
		banks():BankType[]{
			return this.BankService.getTypes();
		}
	},
	watch: {
		banks(){
			for (let i = this.settings.CtepDefaultBankForPaymentTypes.length-1; i>=0;i--){
				let bankId = this.settings.CtepDefaultBankForPaymentTypes[i].BankTypeID;
				if (this.banks.find(b=>b.ID == bankId) == undefined){
					this.settings.CtepDefaultBankForPaymentTypes.splice(i, 1);
				}
			}
		}
	},
	methods: {
		async save(){
			if (this.saving) return;
			this.saving = true;
			try{
				this.settings = await DossierConfigService.setBankConfig(this.settings);
				this.$wf.notify(this.$ct("common.success").toString(), "success", 3000, "check");
			}catch(err){

			}
			this.saving = false;
		},
		getBrandName(brandId:CtepBrandID){
			return getBrandName(brandId);
		},
		getBankName(bankId:number):string{
			let bank = this.banks.find(b=>b.ID == bankId);
			if (!bank) return this.$ct("missing-bank").toString();
			return bank.Name;
		},
		addBankPerBrand(){
			this.toEditBankIdForBrandSetting = {BankTypeID: 0, PaymentType: ""} as any as ICtepDefaultBankForPaymentType;
		},
		onConfirmToAddBankIdForBrandSetting(){
			if (!this.toEditBankIdForBrandSetting) return;
			let i = this.settings.CtepDefaultBankForPaymentTypes.findIndex(b=>b.PaymentType == this.toEditBankIdForBrandSetting?.PaymentType);
			if (i == -1){
				this.settings.CtepDefaultBankForPaymentTypes.push(this.toEditBankIdForBrandSetting);
			}else{
				this.settings.CtepDefaultBankForPaymentTypes[i] = this.toEditBankIdForBrandSetting;
			}
		},
		editBankForIdSetting(setting:ICtepDefaultBankForPaymentType){
			this.toEditBankIdForBrandSetting = setting;
		},
		deleteBankForIdSetting(setting:ICtepDefaultBankForPaymentType){
			let i = this.settings.CtepDefaultBankForPaymentTypes.findIndex(b=>b.PaymentType == setting.PaymentType);
			if (i == -1)return;
			this.settings.CtepDefaultBankForPaymentTypes.splice(i, 1);
		}
	},
	components: {
		AppBankConfigureCtepTerminalBankPerBrandSettings
	},
	i18nEx: {
		componentPrefix: "components.settings-default"
	}
});
